import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

import { InputText } from "primereact/inputtext";
// import { Accordion, AccordionTab } from 'primereact/accordion';
import Accordion from "react-bootstrap/Accordion";
import {
	Button,
	Col,
	Container,
	Form,
	OverlayTrigger,
	Row,
	Spinner,
	Tooltip,
} from "react-bootstrap";
import { Button as ButtonPrime } from "primereact/button";
import Error from "../../../../components/Error";
import { ContentBody } from "../../styled";

import { MdAdd, MdOutlineDvr } from "react-icons/md";
import { HiOutlineArrowCircleLeft } from "react-icons/hi";

import {
	editPhase,
	getCourse,
	getCourseDisiplineLeaf,
	newPhase,
	removeDiscipline,
	removePhase,
} from "../../../../services/manager/admin/courses.service";
import { toast } from "react-toastify";
import { Modal } from "../../../../components/modal";
import { DisciplinesTable } from "../../components/table-disciplines-course";

const validationSchema = Yup.object({
	fase: Yup.string().trim().required("Este campo é obrigatório"),
}).required();

const validationSchemaEdit = Yup.object({
	faseEdit: Yup.string()
		.trim()
		.required("Este campo é obrigatório")
		.max(30, "Tamanho máximo do nome da fase é de 30 caracteres"),
}).required();

export const ViewCourse = (): JSX.Element => {
	const history = useHistory();
	const { t: translation } = useTranslation();
	const { id } = useParams<{ id: string }>();
	const {
		register,
		handleSubmit,
		formState: { errors },
		reset,
	} = useForm({ resolver: yupResolver(validationSchema) });
	const {
		register: registerEdit,
		setValue,
		handleSubmit: handleSubmitEdit,
		formState: { errors: errorsEdit },
		reset: resetEdit,
	} = useForm({ resolver: yupResolver(validationSchemaEdit) });

	const [loading, setLoading] = useState<boolean>(false);
	const [loadingModal, setLoadingModal] = useState<boolean>(false);
	const [loadingButtonAddFase, setLoadingButtonAddFase] =
		useState<boolean>(false);
	const [loadingButtonEditFase, setLoadingButtonEditFase] =
		useState<boolean>(false);
	const [showAddFaseField, setShowAddFaseField] = useState<boolean>(false);
	const [showEditFaseField, setShowEditFaseField] = useState<boolean>(false);
	const [showRemovePhaseModal, setShowRemovePhaseModal] =
		useState<boolean>(false);
	const [valueNameEditPhase, setValueNameEditPhase] = useState<string>("");
	const [courseName, setCourseName] = useState<string>("");
	const [phaseSelected, setPhaseSelected] = useState<any>();
	const [phases, setPhases] = useState<any[]>([]);
	const [disciplines, setDisciplines] = useState<any[]>([]);
	const [accordionKey, setAccordionKey] = useState<any[]>([]);

	const [loadingOnExpand, setLoadingOnExpand] = useState<boolean>(false);

	const treeTableConfig = [
		{
			field: "name",
			header: "Nome",
			nameTemplate: true,
			expander: true,
			style: { textAlign: "left" },
		},
		{
			field: "",
			actionsTemplate: true,
			header: "Ações",
			style: { textAlign: "center", width: "8%" },
		},
	];

	const onSubmitNewFase = (formData: any) => {
		setLoadingButtonAddFase(true);
		let obj = {
			name: formData.fase,
			course: id,
		};

		newPhase(obj)
			.then(() => {
				toast.success("Fase criada com sucesso!");
				getCoursesList();
				setShowAddFaseField(false);
				reset();
			})
			.catch((err: any) => {
				toast.error(err.response.data.message);
			})
			.finally(() => {
				setLoadingButtonAddFase(false);
			});
	};

	const onSubmitEditFase = (formData: any) => {
		setLoadingButtonEditFase(true);
		let obj = {
			name: formData.faseEdit,
			course: id,
		};

		editPhase(phaseSelected.id, obj)
			.then(() => {
				toast.success("Fase alterada com sucesso!");
				getCoursesList();
				setShowEditFaseField(false);
				resetEdit();
			})
			.catch((err: any) => {
				toast.error(err.response.data.message);
			})
			.finally(() => {
				setLoadingButtonEditFase(false);
			});
	};

	const handleEditFase = (fase: any) => {
		setAccordionKey([fase.id]);
		setValue("faseEdit", fase.name);
		setValueNameEditPhase(fase.name);
		setShowEditFaseField(true);
		setPhaseSelected(fase);
	};

	const handleClickItemAccordion = (e: any, fase: any) => {
		if (e.target.attributes.getNamedItem("data-type")) {
			var type = e.target.attributes.getNamedItem("data-type").value;

			if (type === "edit") {
				handleEditFase(fase);
			} else if (type === "remove") {
				setPhaseSelected(fase);
				setShowRemovePhaseModal(true);
				setShowEditFaseField(false);
			} else if (type === "collapse") {
				setShowEditFaseField(false);
				if (accordionKey.includes(fase.id)) {
					setAccordionKey([]);
				} else {
					setAccordionKey([fase.id]);
				}
			}
		} else if (e.target.classList.contains("pi-pencil")) {
			handleEditFase(fase);
		} else if (e.target.classList.contains("pi-trash")) {
			setPhaseSelected(fase);
			setShowRemovePhaseModal(true);
			setShowEditFaseField(false);
		} else if (
			e.target.classList.contains("accordion-button") ||
			e.target.classList.contains("name-phase")
		) {
			setShowEditFaseField(false);
			if (accordionKey.includes(fase.id)) {
				setAccordionKey([]);
			} else {
				setAccordionKey([fase.id]);
			}
		}
	};

	const getCoursesList = () => {
		setLoading(true);
		getCourse(id)
			.then((course: any) => {
				setCourseName(course.name);
				setPhases(course.steps);

				if (course.disciplines) {
					setDisciplines(formatArrObj(course.disciplines));
				} else {
					setDisciplines([]);
				}
			})
			.finally(() => {
				setLoading(false);
			});
	};

	const onExpandDicipline = (event: any, step_id?: number) => {
		if (!event.node.children) {
			setLoadingOnExpand(true);
			let children: any = [];
			let array = disciplines;

			getCourseDisiplineLeaf(event.node.data.discipline_id)
				.then((response: any) => {
					response.items.map((node: any, index: number) => {
						let n = {
							key: node.data.id + "_item",
							...node,
						};
						children.push(n);
					});

					if (!step_id) {
						let i = array.findIndex(
							(no) => no.key === event.node.key
						);
						array[i].children = children;

						setDisciplines(array);
					} else if (step_id) {
						let step_index = phases.findIndex(
							(phase) => phase.id === step_id
						);
						let step_discipline = [
							...formatArrObj(phases[step_index]["disciplines"]),
						];

						let i = step_discipline.findIndex(
							(no: any) => no.key === event.node.key
						);
						step_discipline[i].children = children;

						phases[step_index]["disciplines"] = [
							...step_discipline,
						];
						setPhases([...phases]);
					}
				})
				.finally(() => {
					setLoadingOnExpand(false);
				});
		}
	};

	const submitDeletePhase = () => {
		setLoadingModal(true);
		removePhase(phaseSelected.id)
			.then(() => {
				toast.success("Fase removida com sucesso!");
				setLoadingModal(false);
				setShowRemovePhaseModal(false);
				getCoursesList();
			})
			.catch((err: any) => {
				toast.error(err.response.data.message);
				setLoadingModal(false);
			});
	};

	const handleRemoveDiscipline = (node: any) => {
		removeDiscipline(id, node.data.discipline_id)
			.then(() => {
				toast.success("Disciplina desvinculada com sucesso!");
				getCoursesList();
			})
			.catch((err: any) => {
				toast.error(err.response.data.message);
			});
	};

	const formatArrObj = (arrToFormat: any) => {
		let arr: any[] = [];
		arrToFormat.map((item: any) => {
			if (!item.key) {
				let obj = {
					key: item["discipline_id"],
					data: item,
					leaf: !item["leaf"],
				};
				arr.push(obj);
			} else {
				arr.push(item);
			}
		});

		return arr;
	};

	useEffect(() => {
		getCoursesList();
	}, []);

	if (loading) {
		return (
			<div className="loading-container mt-5">
				<Spinner animation="border" variant="primary" />
			</div>
		);
	}

	return (
		<Container fluid>
			<Row>
				<Col>
					<h4>
						<OverlayTrigger
							placement={"top"}
							overlay={<Tooltip>Voltar</Tooltip>}
						>
							<span>
								<HiOutlineArrowCircleLeft
									size={25}
									style={{
										marginRight: "10px",
										marginBottom: "6px",
										cursor: "pointer",
									}}
									onClick={() => history.goBack()}
								/>
							</span>
						</OverlayTrigger>
						<b>{courseName}</b>
					</h4>
					<p className="mb-3 text-black">
						Adicione as disciplinas que deseja utilizar para compor
						sua matriz curricular.
					</p>
				</Col>
				<Col xs={4} className="text-end">
					<Button
						variant="outline-primary"
						onClick={() =>
							history.push(`/manager/edit-course/${id}`)
						}
					>
						Editar curso
					</Button>
				</Col>
				<Col xs={12} className="mt-2">
					<Button
						variant="outline-primary"
						className="mr-2"
						onClick={() => {
							setShowAddFaseField(true);
						}}
					>
						Adicionar fase <MdAdd />
					</Button>
					<Button
						variant="primary"
						onClick={() =>
							history.push(
								`/manager/sync-disciplines?courseId=${id}`
							)
						}
					>
						Adicionar disciplina
					</Button>
				</Col>
			</Row>
			<ContentBody>
				{showAddFaseField && (
					<Row>
						<Col xs={12} className="d-flex mt-3">
							<Form
								onSubmit={handleSubmit(onSubmitNewFase)}
								className="mb-4"
							>
								<div>
									<label className="block w-100">
										Nome da fase
									</label>
									<InputText
										{...register("fase", {
											required: true,
										})}
										type="text"
										style={{ height: "40px" }}
									/>
									{loadingButtonAddFase ? (
										<Spinner
											animation="border"
											variant="primary"
											className="ml-3"
											style={{
												width: "2rem",
												height: "2rem",
												borderWidth: "0.25em",
												borderRightColor: "transparent",
											}}
										/>
									) : (
										<>
											<Button
												type="submit"
												variant="primary"
												className="mr-2 ml-2 mb-1"
											>
												Salvar
											</Button>
											<Button
												variant="outline-primary"
												className="mb-1"
												onClick={() =>
													setShowAddFaseField(false)
												}
											>
												Cancelar
											</Button>
										</>
									)}
								</div>
								{errors.fase ? (
									<div className="w-100">
										{" "}
										<Error>
											{errors.fase?.message}
										</Error>{" "}
									</div>
								) : (
									""
								)}
							</Form>
						</Col>
					</Row>
				)}

				{phases.length === 0 && disciplines.length === 0 ? (
					<div
						className="text-center"
						style={{ marginTop: "20vh", color: "#D9D9D9" }}
					>
						<MdOutlineDvr size={75} />
						<h4 className="text-grey">
							Nenhuma disciplina adicionada
						</h4>
					</div>
				) : (
					<Col xs={12} className="mt-4 mb-3">
						{disciplines.length > 0 && (
							<DisciplinesTable
								key="disciplinTable"
								nodes={formatArrObj(disciplines)}
								treeFields={treeTableConfig}
								handleRemoveDiscipline={handleRemoveDiscipline}
								onExpand={onExpandDicipline}
								loading={loadingOnExpand}
							/>
						)}
						<Accordion
							activeKey={accordionKey}
							className="accordion-phase mt-4"
						>
							{phases.map((item) => (
								<Accordion.Item
									eventKey={item.id}
									data-type="collapse"
									onClick={(e: any) =>
										handleClickItemAccordion(e, item)
									}
								>
									<Accordion.Header>
										<Row
											data-type="collapse"
											className="d-flex justify-content-between align-items-center w-100"
										>
											<Col
												data-type="collapse"
												style={{ marginLeft: "35px" }}
											>
												<b className="name-phase">
													{item.name}
												</b>
											</Col>
											<Col
												data-type="collapse"
												className="text-end"
											>
												<OverlayTrigger
													placement={"top"}
													overlay={
														<Tooltip>
															Editar Fase
														</Tooltip>
													}
												>
													<ButtonPrime
														data-type="edit"
														icon="pi pi-pencil"
														className="p-button-rounded p-button-text text-darker-grey"
														onClick={() =>
															handleEditFase(item)
														}
													/>
												</OverlayTrigger>

												<OverlayTrigger
													placement={"top"}
													overlay={
														<Tooltip>
															Remover Fase
														</Tooltip>
													}
												>
													<ButtonPrime
														data-type="remove"
														icon="pi pi-trash"
														className="p-button-rounded p-button-text text-darker-grey"
														onClick={() => {
															setShowRemovePhaseModal(
																true
															);
															setPhaseSelected(
																item
															);
														}}
													/>
												</OverlayTrigger>
											</Col>
										</Row>
									</Accordion.Header>
									<Accordion.Body>
										<Row>
											<Col xs={12}>
												{showEditFaseField ? (
													<Form
														onSubmit={handleSubmitEdit(
															onSubmitEditFase
														)}
														className="mb-4"
													>
														<div className="d-flex align-items-center">
															<InputText
																placeholder="Nome da fase"
																value={
																	valueNameEditPhase
																}
																onChange={(
																	e: any
																) => {
																	setValueNameEditPhase(
																		e.target
																			.value
																	);
																	setValue(
																		"faseEdit",
																		e.target
																			.value
																	);
																}}
																type="text"
																style={{
																	height: "40px",
																}}
															/>
															{loadingButtonEditFase ? (
																<div className="">
																	<Spinner
																		animation="border"
																		variant="primary"
																		className="ml-3"
																		style={{
																			width: "2rem",
																			height: "2rem",
																			borderWidth:
																				"0.25em",
																			borderRightColor:
																				"transparent",
																		}}
																	/>
																</div>
															) : (
																<>
																	<Button
																		type="submit"
																		variant="primary"
																		className="mr-2 ml-2"
																	>
																		Salvar
																	</Button>
																	<Button
																		variant="outline-primary"
																		className=""
																		onClick={() =>
																			setShowEditFaseField(
																				false
																			)
																		}
																	>
																		Cancelar
																	</Button>
																</>
															)}
														</div>
														{errorsEdit.faseEdit ? (
															<div className="w-100">
																{" "}
																<Error>
																	{
																		errorsEdit
																			.faseEdit
																			?.message
																	}
																</Error>{" "}
															</div>
														) : (
															""
														)}
													</Form>
												) : (
													<Button
														variant="primary"
														className="mt-0"
														onClick={() =>
															history.push(
																`/manager/sync-disciplines?faseId=${item.id}`
															)
														}
													>
														Adicionar disciplina
													</Button>
												)}
											</Col>
										</Row>

										{item.disciplines.length === 0 ? (
											<div
												className="text-center mb-3"
												style={{ color: "#D9D9D9" }}
											>
												<MdOutlineDvr size={55} />
												<h5 className="text-grey font-400">
													Nenhuma disciplina
													adicionada
												</h5>
											</div>
										) : (
											<DisciplinesTable
												key={item.id + "Table"}
												className="mt-3"
												nodes={formatArrObj(
													item.disciplines
												)}
												treeFields={treeTableConfig}
												handleRemoveDiscipline={
													handleRemoveDiscipline
												}
												onExpand={(event: any) =>
													onExpandDicipline(
														event,
														item.id
													)
												}
												loading={loadingOnExpand}
											/>
										)}
									</Accordion.Body>
								</Accordion.Item>
							))}
						</Accordion>
					</Col>
				)}
			</ContentBody>

			<Modal
				headerTitle="Aviso"
				submitButtonText={translation("manager.links.remove")}
				show={showRemovePhaseModal}
				onHide={() => setShowRemovePhaseModal(false)}
				onSubmit={submitDeletePhase}
				variant="confirm-modal"
				loading={loadingModal}
			>
				{phaseSelected && phaseSelected.disciplines.length > 0 ? (
					<>
						<p className="font-16">
							Você possui {phaseSelected.disciplines.length}{" "}
							disciplinas adicionadas nessa fase. Tem certeza que
							deseja excluí-la?
						</p>
						<p className="font-14 mt-3">
							Todas as disciplinas desta fase serão excluídas do
							curso.
						</p>
					</>
				) : (
					<p>
						Tem certeza que deseja excluir a fase{" "}
						<b className="span-ellipsis">
							{phaseSelected ? phaseSelected.name : ""}?
						</b>
					</p>
				)}
			</Modal>
		</Container>
	);
};
